// src/pages/admin/editorTabs/AiDesignTab.jsx
import React from "react";

export default function AiDesignTab({
  aiDetails,
  setAiDetails,
  aiGenerating,
  onGenerate,
  logoUrl,
}) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border p-5 space-y-5">
      <div>
        <div className="font-bold text-gray-900">AI Design Generator</div>
        <p className="text-sm text-gray-500 mt-1">
          Add a short paragraph about the business. The AI will use the uploaded logo from General,
          choose the best sections/templates, and fill the page design.
        </p>
      </div>

      {logoUrl ? (
        <div className="flex items-center gap-3 p-3 rounded-xl border bg-gray-50">
          <div className="h-12 w-12 rounded-xl border bg-white overflow-hidden flex items-center justify-center">
            <img src={logoUrl} alt="logo" className="h-full w-full object-cover" />
          </div>
          <div>
            <div className="font-medium text-gray-900">Logo detected</div>
            <div className="text-xs text-gray-500">AI will use it for colors and style.</div>
          </div>
        </div>
      ) : (
        <div className="p-3 rounded-xl border border-yellow-200 bg-yellow-50 text-sm text-yellow-800">
          No logo uploaded. Upload a logo in General for better results.
        </div>
      )}

      <div>
        <div className="text-sm font-medium text-gray-700 mb-1">Business Details</div>
        <textarea
          rows={9}
          value={aiDetails}
          onChange={(e) => setAiDetails(e.target.value)}
          className="w-full px-3 py-2 border rounded-lg"
          placeholder="Example: Baron sells pure copper bars 99.9% for investment and premium gifting. The design should feel luxury, trustworthy, modern, and suitable for Arabic customers..."
        />
      </div>

      <button
        type="button"
        onClick={onGenerate}
        disabled={aiGenerating}
        className="px-4 py-3 rounded-xl bg-gray-900 text-white font-medium hover:bg-black disabled:opacity-50"
      >
        {aiGenerating ? "Generating..." : "Generate Complete Page Design"}
      </button>

      <div className="text-xs text-gray-500">
        This will replace the current navigation, sections, and footer in the editor. Review it, then click Save.
      </div>
    </div>
  );
}